<template>
  <div
    v-if="projects && projects.length > 1"
    class="w-1/6"
  >
    <label
      class="ml-4"
      for="projectFilter"
    > {{ $t('Project') }} </label>
    <select
      id="projectFilter"
      v-model="selectedProjectId"
      class="w-11/12 rounded-lg mx-1 py-2 pl-2 bg-gray-200 text-sm"
    >
      <option :value="0">
        {{ $t('All') }}
      </option>
      <option
        v-for="project in projects"
        :key="project.id"
        :value="project.id"
      >
        {{ project.name }}
      </option>
    </select>
  </div>
</template>

<script>
import { actionNames } from '@/store'

export default {
  name: 'ProjectFilter',
  computed: {
    projects () {
      return this.$store.state.projects.projects
    },
    selectedProjectId: {
      get () {
        return this.$store.state.overview.selectedProjectId
      },
      set (projectId) {
        this.$store.dispatch(actionNames.SET_SELECTED_PROJECT_ID, projectId)
      }
    }
  }
}
</script>
